(() => {
  'use strict';

  if (window.location.hostname !== 'ar.gelinlik21.com.tr') return;

  const ROOT_SELECTOR = '[data-g21-arabic-root]';

  const formatMoney = (amount, currency) => {
    const numeric = Number(amount || 0) / 100;
    try {
      return new Intl.NumberFormat('ar', {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: 2
      }).format(numeric);
    } catch (_) {
      return numeric.toFixed(2);
    }
  };

  const stopMedia = (element) => {
    element.querySelectorAll('video').forEach((video) => video.pause());
    element.querySelectorAll('iframe').forEach((iframe) => {
      const src = iframe.src;
      iframe.src = src;
    });
  };

  const showMedia = (gallery, mediaId) => {
    gallery.querySelectorAll('[data-g21-media-id]').forEach((media) => {
      const active = String(media.dataset.g21MediaId) === String(mediaId);
      media.hidden = !active;
      media.classList.toggle('is-active', active);
      if (!active) stopMedia(media);
    });

    gallery.querySelectorAll('[data-g21-media-target]').forEach((button) => {
      const active = String(button.dataset.g21MediaTarget) === String(mediaId);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });
  };

  const initGallery = (root) => {
    root.querySelectorAll('[data-g21-gallery]').forEach((gallery) => {
      gallery.addEventListener('click', (event) => {
        const button = event.target.closest('[data-g21-media-target]');
        if (!button) return;
        showMedia(gallery, button.dataset.g21MediaTarget);
      });
    });
  };

  const selectedOptions = (formRoot) => Array.from(formRoot.querySelectorAll('[data-g21-option-position]'))
    .sort((a, b) => Number(a.dataset.g21OptionPosition) - Number(b.dataset.g21OptionPosition))
    .map((group) => group.querySelector('[data-g21-option-input]:checked')?.value || '');

  const initProductForm = (root) => {
    const formRoot = root.querySelector('[data-g21-product-form]');
    if (!formRoot) return;

    const variantsElement = formRoot.querySelector('[data-g21-variants-json]');
    let variants = [];
    try {
      variants = JSON.parse(variantsElement?.textContent || '[]');
    } catch (error) {
      console.error('[G21 Arabic] Variant data could not be parsed.', error);
    }

    const idInput = formRoot.querySelector('[data-g21-variant-id]');
    const price = formRoot.querySelector('[data-g21-price]');
    const compare = formRoot.querySelector('[data-g21-compare]');
    const addButton = formRoot.querySelector('[data-g21-add-to-cart]');
    const addLabel = formRoot.querySelector('[data-g21-add-label]');
    const currency = formRoot.dataset.currency || 'USD';
    const gallery = root.querySelector('[data-g21-gallery]');

    const refresh = () => {
      const options = selectedOptions(formRoot);
      const variant = variants.find((item) => Array.isArray(item.options) && item.options.every((value, index) => value === options[index]));

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'التركيبة غير متوفرة';
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price, currency);

      if (compare) {
        const showCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        compare.hidden = !showCompare;
        compare.textContent = showCompare ? formatMoney(variant.compare_at_price, currency) : '';
      }

      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'أضف إلى السلة' : 'غير متوفر';

      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      if (gallery && mediaId) showMedia(gallery, mediaId);

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (_) {}
    };

    formRoot.addEventListener('change', (event) => {
      if (event.target.matches('[data-g21-option-input]')) refresh();
    });

    const quantity = formRoot.querySelector('[data-g21-quantity]');
    formRoot.querySelector('[data-g21-quantity-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    formRoot.querySelector('[data-g21-quantity-plus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    });
  };

  const initCollectionTools = (root) => {
    const form = root.querySelector('[data-g21-collection-form]');
    if (!form) return;

    form.querySelector('[data-g21-sort]')?.addEventListener('change', () => form.submit());

    const filters = form.querySelector('[data-g21-filters]');
    const toggle = form.querySelector('[data-g21-filter-toggle]');
    const close = form.querySelector('[data-g21-filter-close]');

    const setOpen = (open) => {
      if (!filters || !toggle) return;
      filters.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };

    toggle?.addEventListener('click', () => setOpen(true));
    close?.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  };

  const init = (root) => {
    if (root.dataset.g21Initialized === 'true') return;
    root.dataset.g21Initialized = 'true';
    initGallery(root);
    initProductForm(root);
    initCollectionTools(root);
  };

  const initializeAll = () => document.querySelectorAll(ROOT_SELECTOR).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
